'use client';

/**
 * connect0 skill §Q.9 — per-route error boundary (spec 192-d D1).
 */
import { RouteError } from '@/components/route-error';

export default function RouteErrorBoundary(props: { error: Error & { digest?: string }; reset: () => void }) {
  return <RouteError {...props} label="Integration job" />;
}
